export default {
    UPDATE_APPOINTMENT: 'UPDATE_APPOINTMENT'
}